import { render, staticRenderFns } from "./ClientTypes.vue?vue&type=template&id=1389a5aa&"
import script from "./ClientTypes.vue?vue&type=script&lang=js&"
export * from "./ClientTypes.vue?vue&type=script&lang=js&"
import style0 from "./ClientTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports